// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"SendResultsByEmail_iconSync__3uncz","fa-spin":"SendResultsByEmail_fa-spin__1QGEK","accordionHeader":"SendResultsByEmail_accordionHeader__3hMcH"};